import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createTrip, deleteTrip, listTrips, updateTrip, type TripFields } from "@/lib/api/trips";

const tripKeys = { list: (workspaceId: string) => ["trips", workspaceId] as const };

export function useTrips(workspaceId: string | undefined) {
  return useQuery({
    queryKey: tripKeys.list(workspaceId ?? ""),
    queryFn: () => listTrips(workspaceId!),
    enabled: Boolean(workspaceId),
  });
}

function useInvalidateTrips() {
  const queryClient = useQueryClient();
  return () => void queryClient.invalidateQueries({ queryKey: ["trips"] });
}

export function useSaveTrip(workspaceId: string) {
  const invalidate = useInvalidateTrips();
  return useMutation({
    mutationFn: ({ id, fields }: { id?: string; fields: TripFields }) =>
      id ? updateTrip(id, fields) : createTrip(workspaceId, fields),
    onSuccess: invalidate,
  });
}

export function useDeleteTrip() {
  const invalidate = useInvalidateTrips();
  return useMutation({ mutationFn: deleteTrip, onSuccess: invalidate });
}
